<template>
  <!-- 文章讯息 -->
  <div class="barF5">
    
  </div>
</template>

<script>
  export default {
    name: 'HelloWorld',
    props: {
      newsList: {
        type: Array,
        default: () => 
          [{
            id: '1',
            title: '關於力量的一點體會1',
            time: '2018-01-12'
          },{
            id: '2',
            title: '關於力量的一點體會2',
            time: '2018-01-12'
          },{
            id: '3',
            title: '關於力量的一點體會3',
            time: '2018-01-12'
          },{
            id: '4',
            title: '關於力量的一點體會4',
            time: '2018-01-12'
          }]
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .barF5{
    height:0.53rem;
    background:rgba(245,245,245,1);
  }
 
</style>